import { Button, Form, FormProps, Icons, Input, Select, Space, useSelect } from "@pankod/refine-antd";
import { useOne } from "@pankod/refine-core";
import { RenderSpinner } from "components/common";
import { ICloudOrganization, ILocations, ILookup, IScreeningMetadata } from "interfaces";
import { arrayExtensions } from "lib-common";
import { DATAPROVIDER_LOOKUP, RESOURCE_PATH, STALE_DURATION } from "scripts/site";


export const CloudScreeningFilter: React.FC<{
    formProps: FormProps,
    onApplyFilter: () => void,
}> = (props) => {
    const { isLoading, data: metadata } = useOne<IScreeningMetadata>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.METADATA,
        id: RESOURCE_PATH.CLOUD_SCREENING,
        queryOptions: {
            enabled: true,
            staleTime: STALE_DURATION,
        },
    });

    // Select hook for cloud organization and group lookup
    const { selectProps: cloudOrganizationProps } = useSelect<ICloudOrganization>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.CLOUD_ORGANIZATION,
        optionLabel: "name",
        optionValue: "id",
        fetchSize: 100,
        filters: [
            {
                field: "enabled",
                operator: "eq",
                value: true,
            },
        ],
        sort: [
            {
                field: "name",
                order: "asc"
            },
        ],
    });


    const { selectProps: userProps } = useSelect<ILookup>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.PEOPLE,
        optionLabel: "nameEmail",
        optionValue: "id",
        filters: [{
            field: "stateManager.state",
            operator: "eq",
            value: "active",
        },
        {
            field: "id",
            operator: "contains",
            value: "@microsoft.com",
        }],
        sort: [{ field: "lastAccessedAt", order: "desc" }],
        fetchSize: 50,
    });

    const { selectProps: countryProps } = useSelect<ILocations>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.COUNTRY,
        optionLabel: "name",
        optionValue: "id",
        sort: [{ field: "name", order: "asc" }],
        fetchSize: 100,
        filters: [{ field: "cloudScreening.enabled", operator: "eq", value: true }],
    });

    return (
        isLoading ? <RenderSpinner message="Loading..." /> :
            <Form layout="vertical" {...props.formProps} autoComplete="off">

                <Form.Item label="TCS Employee Id" name="tcsEmployeeId">
                    <Input placeholder="Enter TCS Employee Id" />
                </Form.Item>

                <Form.Item label="Associate" name="associateId">
                    <Select allowClear showSearch placeholder="Search Name or Email" {...userProps} />
                </Form.Item>

                <Form.Item label="TCS Manager" name="managerUserId">
                    <Select allowClear showSearch placeholder="Search Name or Email" {...userProps} />
                </Form.Item>
                <Form.Item
                    label="Request Status"
                    name="state"
                >
                    <Select
                        allowClear
                        mode="multiple"
                        placeholder="Request status"
                    >
                        {arrayExtensions.sortBy("order", metadata?.data?.states ?? [])?.map((m, i) => (
                            <Select.Option value={m.state} key={i}>{m.displayName}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item label="Cloud Organization" name="cloudOrganizationId">
                    <Select
                        allowClear
                        showSearch
                        mode="multiple"
                        placeholder="Select Cloud Organization"
                        {...cloudOrganizationProps}
                    />
                </Form.Item>

                <Form.Item label="Location" name="physicalLocationId">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Location"
                        {...countryProps}
                    />
                </Form.Item>

                <Form.Item>
                    <Space>
                        <Button
                            htmlType="submit"
                            type="primary"
                            icon={<Icons.FilterOutlined />}
                            onClick={() => props.onApplyFilter()}
                        >
                            Apply
                        </Button>
                        <Button
                            icon={<Icons.ClearOutlined />}
                            htmlType="submit"
                            onClick={() => props.formProps.form?.resetFields()}
                        >
                            Clear
                        </Button>
                    </Space>
                </Form.Item>

            </Form>
    );
};
